<template lang="pug">
  #chapter2
    Ch2Intro
    BlogsNavBar
    Ch2Section1
    Ch2Section2
    Ch2Section3
    Ch2Footer
</template>

<script>
import Ch2Intro from "@/components/chapter2/Ch2Intro.vue";
import BlogsNavBar from "@/components/BlogsNavBar.vue";
import Ch2Section1 from "@/components/chapter2/Ch2Section1.vue";
import Ch2Section2 from "@/components/chapter2/Ch2Section2.vue";
import Ch2Section3 from "@/components/chapter2/Ch2Section3.vue";
import Ch2Footer from "@/components/chapter2/Ch2Footer.vue";

export default {
  name: "Chapter2",
  components: {
    Ch2Intro,
    BlogsNavBar,
    Ch2Section1,
    Ch2Section2,
    Ch2Section3,
    Ch2Footer
  }
};
</script>

<style lang="scss"></style>
